import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import PropTypes from 'prop-types';
import { FiClock, FiFolder, FiGitBranch, FiRepeat } from 'react-icons/fi';

import AnalysisPropTypes from '../../proptypes/analysis';
import { computeToDuration } from '../../services/computation/computeToDuration';
import TypographyWithIcon from '../common/TypographyWithIcon';
import { AnalysisPrecision } from './AnalysisPrecision';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1, 0),
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: 'auto',
            '& > *': {
                margin: 0,
            },
        },
    },
}));

const AnalysisParameters = ({ analysis, expanded }) => {
    const classes = useStyles();
    return (
        <Box className={classes.root} whiteSpace="nowrap">
            {analysis.project?.name && (
                <TypographyWithIcon icon={<FiFolder />} sx={{ maxWidth: '100%' }}>
                    {decodeURIComponent(analysis.project.name)}
                </TypographyWithIcon>
            )}
            {analysis.gitBranchName && (
                <TypographyWithIcon icon={<FiGitBranch />} noWrap>
                    {analysis.gitBranchName}
                </TypographyWithIcon>
            )}
            <TypographyWithIcon icon={<FiClock />} noWrap>
                {formatDistanceToNow(new Date(analysis.createdAt), {
                    addSuffix: true,
                })}
            </TypographyWithIcon>
            {expanded && (
                <>
                    <TypographyWithIcon icon={<FiRepeat />}>
                        Samples: {analysis.samples}
                    </TypographyWithIcon>
                    {analysis.finishedAt && (
                        <TypographyWithIcon icon={<FiClock />}>
                            Duration:{' '}
                            {computeToDuration(
                                Date.parse(analysis.createdAt),
                                Date.parse(analysis.finishedAt)
                            )}
                        </TypographyWithIcon>
                    )}
                    <AnalysisPrecision analysisId={analysis.id} />
                </>
            )}
        </Box>
    );
};

AnalysisParameters.propTypes = {
    analysis: AnalysisPropTypes,
    expanded: PropTypes.bool,
};

export default AnalysisParameters;
